import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { Icon } from '@saviynt/design-system';
import useStyles from './styles/ExecuteDialog.styles';

function ExecuteDialog({ isOpen, onClose, onExecute, migrating }) {
  const classes = useStyles();
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) setIsClosing(false);
  }, [isOpen]);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 280);
  }, [onClose]);

  if (!isOpen && !isClosing) return null;

  return (
    <div className={`${classes.overlay} ${isClosing ? classes.overlayClosing : ''}`}>
      <div className={`${classes.dialog} ${isClosing ? classes.dialogClosing : ''}`}>
        <button type="button" onClick={handleClose} className={classes.closeButton}>
          <Icon kind="close" size="small" color="--color-neutral-1100" />
        </button>
        <Typography variant="h6" className={classes.title}>
          Execute Data Import Jobs?
        </Typography>
        <Typography variant="body2" className={classes.description}>
          Do you want to execute the data import jobs immediately?
        </Typography>
        <div className={classes.options}>
          <div className={classes.option}>
            <strong>YES</strong> - Jobs will run now and start importing data
          </div>
          <div>
            <strong>NO</strong> - Jobs will be created but not executed (you can run them later from
            Saviynt)
          </div>
        </div>
        <div className={classes.actions}>
          <button
            type="button"
            onClick={() => onExecute(false)}
            disabled={migrating}
            className={`${classes.buttonSecondary} ${migrating ? classes.buttonDisabled : ''}`}>
            No, Create only
          </button>
          <button
            type="button"
            onClick={() => onExecute(true)}
            disabled={migrating}
            className={`${classes.buttonPrimary} ${migrating ? classes.buttonDisabled : ''}`}>
            {migrating && <div className={classes.spinner} />}
            {migrating ? 'Migrating...' : 'Yes, Execute'}
          </button>
        </div>
      </div>
    </div>
  );
}

ExecuteDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onExecute: PropTypes.func,
  migrating: PropTypes.bool,
};

ExecuteDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onExecute: undefined,
  migrating: false,
};

export default ExecuteDialog;
